<div class="d-flex justify-content-end">
    <div class="message-box">
      <p class="font-size-09 mb-0 mt-1" *ngIf="message.value">{{message.value}}</p>
      <img (click)="photoClick.emit(message.photoUrl)" class="photo-message" *ngIf="message.photoUrl" src="{{message.photoUrl}}" alt="">
      <div class="text-right">
        <i *ngIf="message.isRead" class="fa fa-check-circle font-size-08 ml-2 text-success"></i>
      </div>  
  </div>
</div>
